function loadHotjar() {
  if (window.hotjarLoaded) {
    console.log("hotjar already loaded");
    return;
  }
  var script = document.createElement('script');
  script.src = "https://t.contentsquare.net/uxa/dd63a16533816.js";
  script.fetchpriority = "low";
  document.head.appendChild(script);
  window.hotjarLoaded = true;
  console.log("Hotjar loaded");
}

function maybeLoadHotjar() {
  var options = window.Shopify.customerPrivacy;
  if (!options) {
    console.log("No consent options yet.");
    return;
  }
  if (!options.analyticsProcessingAllowed() || !options.saleOfDataAllowed()) {
    console.log("skipping hotjar");
    return;
  }

  loadHotjar();
}

window.Shopify.loadFeatures(
 [
   {
     name: 'consent-tracking-api',
     version: '0.1',
   },
 ],
 error => {
   if (error) {
     console.error("failed to get consent api", error);
   }
   maybeLoadHotjar();
 },
);

document.addEventListener("visitorConsentCollected", (event) => maybeLoadHotjar());